module.exports = __webpack_public_path__ + "img/logo.761a3410.png";